import { SEARCH } from "../../../constants/perspectives";
import itemFactory from "./ItemFactory";
export default (({
  options,
  newFilters
}) => itemFactory({
  options,
  newFilters,
  newPerspective: SEARCH
}));